import { Button } from "../Button";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ReactComponent as HideIcon } from "../../assets/ic-hide-white.svg";
import { showReportedPostById } from "@redux/posts/actions";

import styles from "./index.module.scss";

const ReportedPostBody = ({ hideIcon, postId, modalView }) => {
  const { t } = useTranslation("modals");
  const { t: t1 } = useTranslation("buttons");
  const dispatch = useDispatch();

  const showReportedPostDetails = () => {
    dispatch(showReportedPostById({ postById: postId }));
  };

  return (
    <div
      className={classNames(
        "position-absolute translate-middle top-50 start-50 text-center",
        styles.postBody,
      )}
    >
      {hideIcon && <HideIcon className="text-primary" />}
      <div
        className={classNames(
          "text-body-1 text-semibold mt-3 mb-2 text-primary",
        )}
      >
        {t("REPORTED_POST_BODY_TITLE")}
      </div>
      <div
        className={classNames(
          "text-body-2 text-regular mb-3 text-primary",
          modalView && "mb-4 text-body-2",
        )}
      >
        {t("REPORTED_POST_BODY_MSG")}
      </div>
      <Button color="secondary" size="sm" onClick={showReportedPostDetails}>
        {t1("SEE_POST")}
      </Button>
    </div>
  );
};
export default ReportedPostBody;
